"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayAdaptContract = void 0;
const abi_1 = require("../../abi/abi");
const shared_models_1 = require("@railgun-community/shared-models");
const constants_1 = require("../../models/constants");
const address_1 = require("../../utils/address");
const ethers_1 = require("ethers");
class RelayAdaptContract {
    contract;
    constructor(networkName) {
        const network = shared_models_1.NETWORK_CONFIG[networkName];
        if (!(0, shared_models_1.isDefined)(network)) {
            throw new Error(`Network not found: ${networkName}`);
        }
        if (!(0, address_1.validateContractAddress)(network.relayAdaptContract)) {
            throw new Error('Invalid address for Relay Adapt contract.');
        }
        this.contract = new ethers_1.Contract(network.relayAdaptContract, abi_1.abi.adapt.relay);
    }
    createERC20TokenData(tokenAddress) {
        return {
            tokenAddress,
            tokenType: 0,
            tokenSubID: constants_1.ZERO_ADDRESS,
        };
    }
    createBaseTokenWrap(amount) {
        return this.contract.wrapBase.populateTransaction(amount ?? 0n);
    }
    createBaseTokenUnwrap(amount) {
        return this.contract.unwrapBase.populateTransaction(amount ?? 0n);
    }
    createBaseTokenTransfer(toAddress, amount) {
        const baseTokenTransfer = {
            token: this.createERC20TokenData(constants_1.ZERO_ADDRESS),
            to: toAddress,
            value: amount ?? 0n,
        };
        return this.contract.transfer.populateTransaction([baseTokenTransfer]);
    }
    createERC20Transfer(toAddress, tokenAddress, amount) {
        const erc20Transfer = {
            token: this.createERC20TokenData(tokenAddress),
            to: toAddress,
            value: amount ?? 0n,
        };
        return this.contract.transfer.populateTransaction([erc20Transfer]);
    }
}
exports.RelayAdaptContract = RelayAdaptContract;
